import { styled } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";

export const IgniteMainWrapper = styled(Box)({
  width: "100%",
});

export const BannerSection = styled(Box)({
  width: "100%",
  backgroundImage: `url(${process.env.PUBLIC_URL}/Assets/Testimonials/testimonials-banner.jpg)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  minHeight: "260px",
});

export const BannerContent = styled(Box)({
  padding: "60px 5%",
  width: "45%",
});

export const BannerTitle = styled(Typography)({
  color: "#FFFFFF",
  fontSize: "34px",
  fontWeight: 600,
});

export const TestimonialWrapper = styled(Box)({
  width: "90%",
  margin: "auto",
  padding: "40px 0",
});

export const HeaderRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "32px",
});

export const SectionTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  marginBottom: "8px",
});

export const SectionSubtitle = styled(Typography)({
  fontSize: "14px",
  color: "#666",
  maxWidth: "620px",
});

export const SortSelect = styled("select")({
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    height: "36px",
    minWidth: "120px",
    padding: "0 36px 0 14px",
    fontSize: "14px",
    fontWeight: 400,
    color: "#8A8A8A",
    backgroundColor: "#FFFFFF",
    border: "1px solid #EEEEEE",
    backgroundImage: `url(${process.env.PUBLIC_URL}/Assets/Testimonials/dropdown-icon.jpg)`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 12px center",
    backgroundSize: "12px",
    outline: "none",
    cursor: "pointer",
    "&:focus": {
    borderColor: "#DDDDDD",
    },
});

export const CardsGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "32px",

  "&.fadeIn": {
    opacity: 1,
    transition: "opacity 0.8s ease",
  },
  "&.fadeOut": {
    opacity: 0,
    transition: "opacity 0.8s ease",
  },

  "@keyframes fadeInUp": {
    from: {
      opacity: 0,
      transform: "translateY(12px)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0)",
    },
  },

  "@keyframes fadeOutDown": {
    from: {
      opacity: 1,
      transform: "translateY(0)",
    },
    to: {
      opacity: 0,
      transform: "translateY(8px)",
    },
  },
});

export const TestimonialCard = styled(Box)({
  overflow: "hidden",
  boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
});

export const VideoThumb = styled(Box)({
  position: "relative",
  height: "200px",

  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
});

export const PlayButton = styled(Box)({
  position: "absolute",
  bottom: "16px",
  right: "16px",
  width: "44px",
  height: "45px",
  borderRadius: "50%",
  cursor: "pointer",
  zIndex: 2,
});

export const PlayIcon = styled("img")({
  width: "14px",
  height: "14px",
  objectFit: "contain",
});

export const DurationBadge = styled(Box)({
  position: "absolute",
  top: "12px",
  right: "12px",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  padding: "6px 10px",
  color: "#FFFFFF",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: 1,
  zIndex: 2,
  overflow: "hidden",
});

export const DurationIcon = styled("img")({
  width: "12px",
  height: "12px",
  maxWidth: "12px",
  maxHeight: "12px",
  display: "block",
  objectFit: "contain",
  flexShrink: 0,
});

export const CardBody = styled(Box)({
  padding: "16px",
});

export const CardTitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
});

export const CardSubtitle = styled(Typography)({
  fontSize: "13px",
  color: "#777",
});

export const QuoteCard = styled(Box)({
  position: "relative",
  border: "1px solid #000000",
  padding: "16px",
  marginTop: "16px",
  background: "#FFFFFF",

  display: "flex",
  flexDirection: "column",
  minHeight: "260px",
});

export const QuoteIcon = styled("img")({
  position: "absolute",
  bottom: "60px",
  right: "20px",
  width: "18px",
  height: "18px",
  objectFit: "contain",
});

export const QuoteText = styled(Typography)({
  fontSize: "14px",
  color: "#555",
  lineHeight: 1.6,
  flexGrow: 1,
});

export const ProfileRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  marginTop: "auto",
  paddingTop: "12px",
});

export const ReadMore = styled(Box)({
  fontSize: "13px",
  color: "#A100FF",
  cursor: "pointer",
  marginTop: "6px",
  alignSelf: "flex-start",
});

export const Avatar = styled(Box)({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  background: "#D9D9D9",
});

export const ProfileInfo = styled(Box)({});

export const ProfileName = styled(Typography)({
  fontSize: "14px",
  fontWeight: 600,
});

export const ProfileRole = styled(Typography)({
  fontSize: "12px",
  color: "#777",
});

export const ViewAllWrapper = styled(Box)({
  display: "flex",
  justifyContent: "center",
  marginTop: "40px",
});

export const ViewAllButton = styled(Button)({
  background: "#A100FF",
  color: "#FFFFFF",
  padding: "10px 22px",
  textTransform: "none",
  borderRadius: "0px",
  fontSize: "14px",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "& .viewAllIcon": {
    fontSize: "20px",
  },
  "&:hover": {
    background: "#A100FF",
  },
});

export const LeadersSection = styled(Box)({
  width: "100%",
  backgroundColor: "#1F0549",
  padding: "40px 0 10px",
  position: "relative",
  zIndex: 1,
});

export const LeadersHeader = styled(Box)({
  width: "90%",
  margin: "auto",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "40px",
});

export const LeadersTitleBlock = styled(Box)({
  maxWidth: "700px",
});

export const LeadersTitle = styled(Typography)({
  color: "#FFFFFF",
  fontSize: "32px",
  fontWeight: 600,
  marginBottom: "12px",
});

export const LeadersSubtitle = styled(Typography)({
  color: "#E0D7F0",
  fontSize: "15px",
  lineHeight: 1.6,
});

export const LeadersNav = styled(Box)({
  display: "flex",
  gap: "12px",
});

export const NavButton = styled(Box)({
  width: "44px",
  height: "44px",
  background: "#A100ff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",

  "&:hover": {
    background: "#A100FF",
  },
});

export const NavIcon = styled("img")({
  width: "14px",
  height: "14px",
  objectFit: "contain",
});

export const LeadersCardsRow = styled(Box)({
  width: "90%",
  margin: "auto",
  overflow: "hidden",
  height: "310px",
  position: "relative",
   zIndex: 2,
});

export const LeaderCard = styled(Box)({
  minWidth: "460px",
  height: "230px",
  background: "#FFFFFF",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  position: "relative",
  overflow: "visible",
});

export const LeaderImageWrap = styled(Box)({
  width: "200px",
  position: "relative",
  overflow: "visible",
  zIndex: 3,
});

export const LeaderImage = styled("img")({
  width: "150px",
  height: "290px",
  objectFit: "cover",
});

export const LeaderContent = styled(Box)({
  padding: "15px",
  display: "flex",
  flexDirection: "column",
});

export const LeaderQuote = styled(Typography)({
  fontSize: "14px",
  color: "#333",
  lineHeight: 1.7,
  marginBottom: "20px",
});

export const LeaderName = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
});

export const LeaderDesignation = styled(Typography)({
  fontSize: "14px",
  color: "#777",
});

export const StatsWrapper = styled(Box)({
  width: "90%",
  margin: "auto",
  padding: "30px 0",
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  alignItems: "center",
  justifyItems: "center"
});

export const StatItem = styled(Box)({});

export const StatValue = styled(Typography)({
  fontSize: "32px",
  fontWeight: 700,
  color: "#A100FF",
  marginBottom: "6px",
});

export const StatLabel = styled(Typography)({
  fontSize: "15px",
  color: "#000",
});

export const LeadersTrack = styled(Box)({
  display: "flex",
  gap: "24px",
  transition: "transform 0.5s ease",
});

export const PaginationWrapper = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "12px",
  marginTop: "40px",
});

export const PaginationButton = styled(Button)({
  minWidth: "26px",
  height: "26px",
  padding: "0",
  marginLeft: "30px",
  marginRight: "30px",
  borderRadius: "50%",
  backgroundColor: "#A100FF",
  opacity: 0.7,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "& img": {
    width: "14px",
    height: "14px",
    objectFit: "contain",
  },

  "&:disabled": {
    opacity: 0.2,
    cursor: "not-allowed",
  },
});

export const PageNumber = styled(Box)(({ active }) => ({
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  background: active ? "#A100FF" : "#F2F2F2",
  color: active ? "#FFFFFF" : "#333",
  fontSize: "14px",
}));
